//import { useState, useContext } from 'react';
//import { useHistory } from 'react-router-dom';
//import axios from 'api';
import api from '../services/api';
import { mutate as mutateGlobal } from 'swr'

export async function mundoConcluido(p_mundo,id_user,mutate){
    //const data={msg:"edu",p_mundo,id_user}
    await api.get(`/a/m${p_mundo}/u${id_user}`);
    //console.log("\n\n+-+-+-+-+mutate...")

    mutateGlobal(`/user/mu${id_user}`,[],true)
}
export async function faseConcluida(p_fase,id_user,mutate){
    const {data} = await api.get(`/a/f${p_fase}/u${id_user}`)
    //console.log(data)
    mutate(data => {
        data.data.fases.push([{id:id_user}])
        return data
    })
    return data;
}
/*userDataM.data.mundos.push({
const update = userDataM => {
    //-dj//console.log("+-+-+-+-+userDataM",userDataM)
        "id": 5,
        "nome": "carregabdo...",
        "position": 5
    })
    return userDataM;
}
return update?update():null
*/
